export default "__VITE_ASSET__801cdb3e__"